import { useState } from "react";
import { Button } from "../Buttons";
import { H3, Label } from "../Text";
import { toast } from "react-toastify";
import { requestAuth } from "../services/RequestService";
import Circle from "../Animation/Circle";

export const FileManagerModal = ({ item, reload, onClose }) => {
  const [loading, setLoading] = useState(false);
  const [fileToUpload, setFileToUpload] = useState(null);
  const [fileDescription, setFileDescription] = useState("");
  const [files, setFiles] = useState(() => {
    try {
      return item.description4 ? JSON.parse(item.description4) : [];
    } catch (e) {
      return [];
    }
  });

  const handleFileChange = (e) => {
    if (e.target.files[0]) {
      setFileToUpload(e.target.files[0]);
    }
  };

  const handleUpload = async () => {
    if (!fileToUpload) return;

    setLoading(true);
    let formData = new FormData();
    formData.append("Name", fileToUpload.name);
    formData.append("File", fileToUpload);
    formData.append("originalName", fileToUpload.name);
    formData.append("Status", "verified");

    try {
      const res = await requestAuth("post", "/files", formData);
      const newFile = {
        name: fileToUpload.name,
        url: res.data.url,
        description: fileDescription,
        date: new Date().toISOString(),
      };

      const updatedFiles = [...files, newFile];
      await updateRecord(updatedFiles);
      setFiles(updatedFiles);
      setFileToUpload(null);
      setFileDescription("");
      toast.success("Archivo subido correctamente");
    } catch (error) {
      toast.error("Error al subir archivo");
    } finally {
      setLoading(false);
    }
  };

  const handleDelete = async (index) => {
    const updatedFiles = files.filter((_, i) => i !== index);
    await updateRecord(updatedFiles);
    setFiles(updatedFiles);
    toast.info("Archivo eliminado de la lista");
  };

  const updateRecord = async (newFilesArray) => {
    const payload = {
      ...item,
      Label: item.label,
      Description4: JSON.stringify(newFilesArray),
    };
    await requestAuth("put", `/dataSet/procedure/subData/${item.id}`, payload);
    reload();
  };

  return (
    <div className="p-6 flex flex-col gap-4 bg-white rounded-xl shadow-2xl min-w-[500px]">
      <H3 className="text-blue-800 border-b pb-2 flex items-center gap-2">
        <i className="fas fa-folder-open"></i> Gestión de Documentos: {item.label}
      </H3>

      <div className="bg-blue-50/50 p-4 rounded-xl border border-blue-100 flex flex-col gap-3">
        {loading ? (
          <div className="flex justify-center p-4"><Circle /></div>
        ) : (
          <>
            <div className="flex flex-col gap-2">
              <Label className="text-xs font-bold text-blue-600 uppercase">1. Seleccionar archivo</Label>
              <input
                type="file"
                onChange={handleFileChange}
                className="text-sm file:mr-4 file:py-2 file:px-4 file:rounded-full file:border-0 file:text-sm file:font-semibold file:bg-blue-600 file:text-white hover:file:bg-blue-700"
              />
            </div>
            {fileToUpload && (
              <div className="flex justify-end animate-fade-in">
                <Button onClick={handleUpload} className="px-6">Subir</Button>
              </div>
            )}
          </>
        )}
      </div>

      <div className="max-h-[250px] overflow-y-auto border rounded-xl">
        <table className="w-full text-xs text-left">
          <thead className="bg-gray-100 text-gray-600 uppercase sticky top-0">
            <tr>
              <th className="px-2 py-2 text-left">Archivo</th>
              <th className="px-2 py-2 text-center w-20">Acciones</th>
            </tr>
          </thead>
          <tbody className="divide-y">
            {files.length === 0 && (
              <tr>
                <td colSpan="2" className="text-center py-4 text-gray-400">
                  No hay documentos cargados
                </td>
              </tr>
            )}
            {files.map((file, idx) => (
              <tr key={idx} className="hover:bg-gray-50">
                <td className="px-2 py-2 truncate max-w-[200px]">
                  <a
                    href={file.url}
                    target="_blank"
                    rel="noreferrer"
                    className="text-blue-600 hover:underline"
                  >
                    {file.name}
                  </a>
                </td>
                <td className="px-2 py-2 flex justify-center gap-2">
                  <button
                    onClick={() => handleDelete(idx)}
                    className="text-red-500 hover:text-red-700"
                  >
                    <i className="fas fa-trash-alt"></i>
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      <div className="flex justify-end mt-4">
        <Button onClick={onClose}>Cerrar</Button>
      </div>
    </div>
  );
};
